import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './router/app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TestComponent } from './components/test/test.component';
import { CreateTenantComponent } from './components/admin-page/components/create-tenant/create-tenant.component';
import { TenantsListComponent } from './components/admin-page/components/tenants-list/tenants-list.component';
import { LicensesPageComponent } from './components/licenses-page/licenses-page.component';
import { ProductListComponent } from './components/admin-page/components/product-list/product-list.component';
import { ProductDetailsComponent } from './components/admin-page/components/product-details/product-details.component';
import { TenantDetailsComponent } from './components/admin-page/components/tenant-details/tenant-details.component';
import { HistoryComponent } from './components/history/history.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { TenantInfoFormComponent } from './components/tenant-info-form/tenant-info-form.component';
import { TenantUsersComponent } from './components/tenant-users/tenant-users.component';
import { TenantInfoSetupFormComponent } from './components/tenant-info-setup-form/tenant-info-setup-form.component';
import { CheckoutPageComponent } from './components/checkout-page/checkout-page.component';
import { ReceiptPageComponent } from './components/receipt-page/receipt-page.component';
import { ShepherdComponent } from './components/shepherd/shepherd.component';
import { SavedPaymentMethodsComponent } from './components/saved-payment-methods/saved-payment-methods.component';
import { ToastTimerComponent } from './components/toast-timer/toast-timer.component';
import { KillSwitchComponent } from './components/admin-page/components/kill-switch/kill-switch.component';
import { EditProductComponent } from './components/admin-page/components/edit-product/edit-product.component';
import { EditProductVariantComponent } from './components/admin-page/components/edit-product-variant/edit-product-variant.component';
import { AddProductComponent } from './components/admin-page/components/add-product/add-product.component';
import { AddProductVariantComponent } from './components/admin-page/components/add-product-variant/add-product-variant.component';
import { ReceiptsPageComponent } from './components/receipts-page/receipts-page.component';
import { EditLicenseComponent } from './components/admin-page/components/edit-license/edit-license.component';
import { LicenseChangeHistoryComponent } from './components/admin-page/components/license-change-history/license-change-history.component';
import { TwoFactorEnrollmentComponent } from './components/login/components/two-factor-enrollment/two-factor-enrollment.component';
import { TwoFactorLoginComponent } from './components/login/components/two-factor-login/two-factor-login.component';
import { GraphicSidePanelComponent } from './components/graphic-side-panel/graphic-side-panel.component';
import { UserSettingsComponent } from './components/user-settings/user-settings.component';
import { QrCodeIconComponent } from './components/icons/qr-code-icon/qr-code-icon.component';
import { MobilePhoneIconComponent } from './components/icons/mobile-phone-icon/mobile-phone-icon.component';
import { TrashIconComponent } from './components/icons/trash-icon/trash-icon.component';
import { TotpEnrollmentComponent } from './components/login/components/totp-enrollment/totp-enrollment.component';
import { SmsEnrollmentComponent } from './components/login/components/sms-enrollment/sms-enrollment.component';
import { ReauthenticateComponent } from './components/login/components/reauthenticate/reauthenticate.component';
import { UserSettingIconComponent } from './components/icons/user-setting-icon/user-setting-icon.component';
import { ClipboardIconComponent } from './components/icons/clipboard-icon/clipboard-icon.component';
import { PresentIconComponent } from './components/icons/present-icon/present-icon.component';
import { PlusIconComponent } from './components/icons/plus-icon/plus-icon.component';
import { EditIconComponent } from './components/icons/edit-icon/edit-icon.component';
import { FileInvoiceIconComponent } from './components/icons/file-invoice-icon/file-invoice-icon.component';
import { UsersIconComponent } from './components/icons/users-icon/users-icon.component';
import { CreditCardIconComponent } from './components/icons/credit-card-icon/credit-card-icon.component';
import { BellIconComponent } from './components/icons/bell-icon/bell-icon.component';
import { SunIconComponent } from './components/icons/sun-icon/sun-icon.component';
import { MoonIconComponent } from './components/icons/moon-icon/moon-icon.component';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';
import { BuildingIconComponent } from './components/icons/building-icon/building-icon.component';
import { UserIconComponent } from './components/icons/user-icon/user-icon.component';
import { GoogleIconComponent } from './components/icons/google-icon/google-icon.component';
import { FileCopyIconComponent } from './components/icons/file-copy-icon/file-copy-icon.component';
import { ManageAuthComponent } from './components/manage-auth/manage-auth.component';
import { HomeIconComponent } from './components/icons/home-icon/home-icon.component';
import { RightArrowIconComponent } from './components/icons/right-arrow-icon/right-arrow-icon.component';
import { TenantInvoiceComponent } from './components/admin-page/components/tenant-invoice/tenant-invoice.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { FranchisesListComponent } from './components/admin-page/components/franchises-list/franchises-list.component';
import { FranchiseDetailsComponent } from './components/admin-page/components/franchise-details/franchise-details.component';
import { ChevronDownIconComponent } from './components/icons/chevron-down-icon/chevron-down-icon.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { UndoIconComponent } from './components/icons/undo-icon/undo-icon.component';
import { CloseIconComponent } from './components/icons/close-icon/close-icon.component';
import { AddLicenseComponent } from './components/admin-page/components/tenant-details/add-license/add-license.component';
import { LeftArrowIconComponent } from './components/icons/left-arrow-icon/left-arrow-icon.component';
import { TenantInfoPageComponent } from './components/tenant-info-page/tenant-info-page.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { TenantAdminEditComponent } from './components/admin-page/components/tenant-admin-edit/tenant-admin-edit.component';
import { CreateInvoiceComponent } from './components/admin-page/components/tenant-details/create-invoice/create-invoice.component';
import { TenantSettingsComponent } from './components/tenant-settings/tenant-settings.component';
import { CogIconComponent } from './components/icons/cog-icon/cog-icon.component';
import { BarsIconComponent } from './components/icons/bars-icon/bars-icon.component';
import { ArrowRightToBracketIconComponent } from './components/icons/arrow-right-to-bracket-icon/arrow-right-to-bracket-icon.component';
import { LightbulbIconComponent } from './components/icons/lightbulb-icon/lightbulb-icon.component';
import { InfoCircleIconComponent } from './components/icons/info-circle-icon/info-circle-icon.component';
import { SavedPaymentCardComponent } from './components/saved-payment-methods/saved-payment-card/saved-payment-card.component';
import { RemovePaymentMethodModalComponent } from './components/saved-payment-methods/remove-payment-method-modal/remove-payment-method-modal.component';
import { AddPaymentMethodModalComponent } from './components/saved-payment-methods/add-payment-method-modal/add-payment-method-modal.component';
import { ChevronUpIconComponent } from './components/icons/chevron-up-icon/chevron-up-icon.component';
import { LicensesTableComponent } from './components/admin-page/components/tenant-details/licenses-table/licenses-table.component';
import { InvoicesTableComponent } from './components/admin-page/components/tenant-details/invoices-table/invoices-table.component';
import { UsersTableComponent } from './components/admin-page/components/tenant-details/users-table/users-table.component';
import { VisaIconComponent } from './components/icons/visa-icon/visa-icon.component';
import { MastercardIconComponent } from './components/icons/mastercard-icon/mastercard-icon.component';
import { AmericanExpressIconComponent } from './components/icons/american-express-icon/american-express-icon.component';
import { DiscoverIconComponent } from './components/icons/discover-icon/discover-icon.component';
import { JcbIconComponent } from './components/icons/jcb-icon/jcb-icon.component';
import { DinersClubIconComponent } from './components/icons/diners-club-icon/diners-club-icon.component';
import { GenericCreditCardIconComponent } from './components/icons/generic-credit-card-icon/generic-credit-card-icon.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ChevronLeftIconComponent } from './components/icons/chevron-left-icon/chevron-left-icon.component';
import { ChevronRightIconComponent } from './components/icons/chevron-right-icon/chevron-right-icon.component';
import { TenantInfoComponent } from './components/admin-page/components/tenant-details/tenant-info/tenant-info.component';
import { RefreshIconComponent } from './components/icons/refresh-icon/refresh-icon.component';
import { UserAddIconComponent } from './components/icons/user-add-icon/user-add-icon.component';
import { CheckIconComponent } from './components/icons/check-icon/check-icon.component';
import { CheckCircleIconComponent } from './components/icons/check-circle-icon/check-circle-icon.component';
import { ShareAllIconComponent } from './components/icons/share-all-icon/share-all-icon.component';
import { ClockIconComponent } from './components/icons/clock-icon/clock-icon.component';
import { InvoicesListComponent } from './components/admin-page/components/invoices-list/invoices-list.component';
import { LicensesListComponent } from './components/admin-page/components/licenses-list/licenses-list.component';
import { ToastWrapperComponent } from './components/toast-wrapper/toast-wrapper.component';
import { ToastComponent } from './components/toast/toast.component';
import { ApiCheckoutPageComponent } from './components/api-checkout-page/api-checkout-page.component';
import { TenantApiInvoiceComponent } from './components/admin-page/components/tenant-api-invoice/tenant-api-invoice.component';
import { CartIconComponent } from './components/icons/cart-icon/cart-icon.component';
import { CartComponent } from './components/cart/cart.component';
import { ApiReceiptPageComponent } from './components/api-receipt-page/api-receipt-page.component';
import { AddApiSubscriptionComponent } from './components/admin-page/components/tenant-details/add-api-subscription/add-api-subscription.component';
import { EditApiSubscriptionComponent } from './components/admin-page/components/edit-api-subscription/edit-api-subscription.component';
import { ApiInvoicesPageComponent } from './components/api-invoices-page/api-invoices-page.component';
import { RegisterComponent } from './components/register/register.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { ApiInvoicesTableComponent } from './components/admin-page/components/tenant-details/api-invoices-table/api-invoices-table.component';
import { ApiJobLogsPageComponent } from './components/api-job-logs-page/api-job-logs-page.component';
import { FileCodeIconComponent } from './components/icons/file-code-icon/file-code-icon.component';
import { ListIconComponent } from './components/icons/list-icon/list-icon.component';
import { ApiJobLogsComponent } from './components/api-job-logs/api-job-logs.component';
import { TenantApiJobLogsComponent } from './components/admin-page/components/tenant-api-job-logs/tenant-api-job-logs.component';
import { LogSearchComponent } from './components/admin-page/components/log-search/log-search.component';
import { ActivationKeysPageComponent } from './components/admin-page/components/activation-keys-page/activation-keys-page.component';
import { RegistrationDbLogsPageComponent } from './components/admin-page/components/registration-db-logs-page/registration-db-logs-page.component';
import { ProductSquashComponent } from './components/admin-page/components/product-squash/product-squash.component';
import { DotsHorizontalIconComponent } from './components/icons/dots-horizontal-icon/dots-horizontal-icon.component';
import { FaqPageComponent } from './components/faq-page/faq-page.component';
import { ThemeToggleComponent } from './components/theme-toggle/theme-toggle.component';
import { LoginSuccessComponent } from './components/login-success/login-success.component';
import { SortHorizontalIconComponent } from './components/icons/sort-horizontal-icon/sort-horizontal-icon.component';
import { EyeIconComponent } from './components/icons/eye-icon/eye-icon.component';
import { EyeSlashIconComponent } from './components/icons/eye-slash-icon/eye-slash-icon.component';
import { EmailActivationKeysComponent } from './components/admin-page/components/tenant-details/email-activation-keys/email-activation-keys.component';
import { SentActivationKeyEmailsComponent } from './components/admin-page/components/tenant-details/sent-activation-key-emails/sent-activation-key-emails.component';
import { TenantActivationKeysComponent } from './components/admin-page/components/tenant-details/tenant-activation-keys/tenant-activation-keys.component';
import { TenantApiKeyComponent } from './components/admin-page/components/tenant-details/tenant-api-key/tenant-api-key.component';
import { TenantDesCreditsComponent } from './components/admin-page/components/tenant-details/tenant-des-credits/tenant-des-credits.component';
import { DatabaseIconComponent } from './components/icons/database-icon/database-icon.component';
import { PricingDisplayComponent } from './components/admin-page/components/pricing-display/pricing-display.component';
import { DollarIconComponent } from './components/icons/dollar-icon/dollar-icon.component';
import { AuthCodeInputComponent } from './components/auth-code-input/auth-code-input.component';
import { BuyDesCreditsPageComponent } from './components/buy-des-credits-page/buy-des-credits-page.component';
import { DesCreditsPageComponent } from './components/des-credits-page/des-credits-page.component';
import { DesCheckoutPageComponent } from './components/des-checkout-page/des-checkout-page.component';
import { DesReceiptPageComponent } from './components/des-receipt-page/des-receipt-page.component';
import { ReceiptIconComponent } from './components/icons/receipt-icon/receipt-icon.component';
import { RectangleListIconComponent } from './components/icons/rectangle-list-icon/rectangle-list-icon.component';
import { LockOpenIconComponent } from './components/icons/lock-open-icon/lock-open-icon.component';

@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent,
    TopNavComponent,
    LoginComponent,
    LoginSuccessComponent,
    DashboardComponent,
    TestComponent,
    CreateTenantComponent,
    TenantsListComponent,
    LicensesPageComponent,
    ProductListComponent,
    ProductDetailsComponent,
    TenantDetailsComponent,
    HistoryComponent,
    SignUpComponent,
    TenantInfoFormComponent,
    TenantUsersComponent,
    TenantInfoSetupFormComponent,
    CheckoutPageComponent,
    ReceiptPageComponent,
    ShepherdComponent,
    SavedPaymentMethodsComponent,
    ToastTimerComponent,
    KillSwitchComponent,
    EditProductComponent,
    EditProductVariantComponent,
    AddProductComponent,
    AddProductVariantComponent,
    ReceiptsPageComponent,
    ApiInvoicesPageComponent,
    ApiCheckoutPageComponent,
    EditLicenseComponent,
    LicenseChangeHistoryComponent,
    TwoFactorEnrollmentComponent,
    TwoFactorLoginComponent,
    GraphicSidePanelComponent,
    UserSettingsComponent,
    QrCodeIconComponent,
    MobilePhoneIconComponent,
    TrashIconComponent,
    TotpEnrollmentComponent,
    SmsEnrollmentComponent,
    ReauthenticateComponent,
    UserSettingIconComponent,
    ClipboardIconComponent,
    PresentIconComponent,
    PlusIconComponent,
    EditIconComponent,
    FileInvoiceIconComponent,
    UsersIconComponent,
    CreditCardIconComponent,
    BellIconComponent,
    SunIconComponent,
    MoonIconComponent,
    MobileNavComponent,
    BuildingIconComponent,
    UserIconComponent,
    GoogleIconComponent,
    FileCopyIconComponent,
    ManageAuthComponent,
    HomeIconComponent,
    RightArrowIconComponent,
    TenantInvoiceComponent,
    CheckoutComponent,
    ReceiptComponent,
    FranchisesListComponent,
    FranchiseDetailsComponent,
    ChevronDownIconComponent,
    EditUserComponent,
    UndoIconComponent,
    CloseIconComponent,
    AddLicenseComponent,
    LeftArrowIconComponent,
    TenantInfoPageComponent,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    TenantAdminEditComponent,
    CreateInvoiceComponent,
    TenantSettingsComponent,
    CogIconComponent,
    ArrowRightToBracketIconComponent,
    BarsIconComponent,
    LightbulbIconComponent,
    InfoCircleIconComponent,
    SavedPaymentCardComponent,
    RemovePaymentMethodModalComponent,
    AddPaymentMethodModalComponent,
    ChevronUpIconComponent,
    LicensesTableComponent,
    InvoicesTableComponent,
    UsersTableComponent,
    VisaIconComponent,
    MastercardIconComponent,
    AmericanExpressIconComponent,
    DiscoverIconComponent,
    JcbIconComponent,
    DinersClubIconComponent,
    GenericCreditCardIconComponent,
    PaginationComponent,
    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    TenantInfoComponent,
    RefreshIconComponent,
    UserAddIconComponent,
    CheckIconComponent,
    CheckCircleIconComponent,
    ShareAllIconComponent,
    ClockIconComponent,
    InvoicesListComponent,
    LicensesListComponent,
    ToastWrapperComponent,
    ToastComponent,
    TenantApiInvoiceComponent,
    CartIconComponent,
    CartComponent,
    ApiReceiptPageComponent,
    AddApiSubscriptionComponent,
    EditApiSubscriptionComponent,
    RegisterComponent,
    CookiePolicyComponent,
    ApiInvoicesTableComponent,
    ApiJobLogsPageComponent,
    FileCodeIconComponent,
    ListIconComponent,
    ApiJobLogsComponent,
    TenantApiJobLogsComponent,
    LogSearchComponent,
    ActivationKeysPageComponent,
    RegistrationDbLogsPageComponent,
    ProductSquashComponent,
    DotsHorizontalIconComponent,
    FaqPageComponent,
    ThemeToggleComponent,
    SortHorizontalIconComponent,
    EyeIconComponent,
    EyeSlashIconComponent,
    EmailActivationKeysComponent,
    SentActivationKeyEmailsComponent,
    TenantActivationKeysComponent,
    TenantApiKeyComponent,
    TenantDesCreditsComponent,
    DatabaseIconComponent,
    PricingDisplayComponent,
    DollarIconComponent,
    AuthCodeInputComponent,
    BuyDesCreditsPageComponent,
    DesCreditsPageComponent,
    DesCheckoutPageComponent,
    DesReceiptPageComponent,
    ReceiptIconComponent,
    RectangleListIconComponent,
    LockOpenIconComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
